/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : sessionStorage.ts
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       :  Sivateja (H267743)
 *
 * @Date         : Sept 13, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Sivateja (H267743)
 * On            : Sept 16, 2019
 * Description   : this will export the utility functions to store & retrieve the state to session storage (ASDS-1175)
 *
 * By            : Sivateja (H267743)
 * On            : Sept 25, 2019
 * Description   : Implemented saving/loading the last route to session storage (ASDS-1288)
 *
 * By            : Sivateja (H267743)
 * On            : oct 10, 2019
 * Description   : Implemented removeing items from session storage (ASDS-1477)
 *
 * By            : H224423
 * On            : NOV 08, 2019
 * Description   : Implemented Order succes - order details with session storage
 *
 * By            : Madhu Gali - H175591
 * On            : Jan 10, 2020
 * Description   : ASDS-2152
 *
 * By            : H422337
 * On            : Nov,06 2020
 * Description   : ASDS-3833- Error handling scenario - place an order
 *
 ******************************************************************************/

/* Loades the data from session storage*/
import CheckoutConstants from '../modules/checkout/constants/checkout-constants';

export const loadState = () => {
    try {
        const serializedState = sessionStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (error) {
        console.error(error);
        return undefined;
    }
};

/* save the given state to session storage */
export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem('state', serializedState);
    } catch (error) {
        console.error(error);
    }
};

/* REMOVES THE KEY FROM THE SESSION STORAGE*/
export const removeItemFromSessionStorage = (key: string) => {
    const prevState = loadState();
    try {
        if (prevState) {
            delete prevState[key];
            saveState(prevState);
        }
    } catch (error) {
        console.error(error);
    }
};

export function saveRoute(location) {
    try {
        const redirectingFrom = sessionStorage.getItem(CheckoutConstants.PREVIOUS_PATH);
        let path = '';
        if (redirectingFrom === null) { // First write to your localStorage
            path = location;
        } else {
            path += `${location}`; // append new path to it
        }
        sessionStorage.setItem(CheckoutConstants.PREVIOUS_PATH, path);
    } catch (error) {
        console.error(error);
    }
}

export function getPreviousRoute() {
    try {
        return sessionStorage.getItem(CheckoutConstants.PREVIOUS_PATH);
    } catch (error) {
        console.error(error);
    }
    return null;
}

/**
 * Saves order details to session
 * @param orderDetails
 */
export function saveOrderDetails(orderDetails: any) {
    try {
        sessionStorage.setItem(CheckoutConstants.ORDER_DETAILS, JSON.stringify(orderDetails));
    } catch (error) {
        console.error(error);
    }
}

export function savefailureOrderDetails(failureRes: any){
    try {
        sessionStorage.setItem(CheckoutConstants.FAILURE_ORDER_RESPONSE, JSON.stringify(failureRes));
    } catch (error) {
        console.error(error);
    }
}

export function getFailureOrderDetails() {
    let failureOrderDetails;
    try {
        failureOrderDetails = sessionStorage.getItem(CheckoutConstants.FAILURE_ORDER_RESPONSE);
    } catch (error) {
        console.error(error);
    }
    return failureOrderDetails !== null ? JSON.parse(failureOrderDetails) : {};
}

/**
 * Removes orderDetails object from the session
 */
export function removeOrderDetails() {
    try {
        sessionStorage.removeItem(CheckoutConstants.ORDER_DETAILS);
    } catch (error) {
        console.error(error);
    }
}

export function removeFailureOrderDetails() {
    try {
        sessionStorage.removeItem(CheckoutConstants.FAILURE_ORDER_RESPONSE);
    } catch (error) {
        console.error(error);
    }
}

/**
 * get order details object from the session
 */
export function getOrderDetails() {
    let orderDetails;
    try {
        orderDetails = sessionStorage.getItem(CheckoutConstants.ORDER_DETAILS);
    } catch (error) {
        console.error(error);
    }
    return orderDetails !== null ? JSON.parse(orderDetails) : {};
}

export function removeSessionStorage(stateRef: string[]) {
    try {
        stateRef.forEach(e => sessionStorage.removeItem(e));
    } catch (error) {
        console.error(error);
    }
}